<template>
    <section class="banner-with-button">
        <div class="banner-content" :class="backgroundColor">
            <div class="banner-content-inner">
                <div v-if="image" class="banner-image-container">
                    <img :src="image" alt="banner-image" class="banner-image" />
                </div>
                <p class="banner-text" :class="messageColor" v-html="message"></p>
            </div>

            <button v-if="buttonText" class="banner-button" :class="buttonColor" @click="$emit('buttonAction')">
                {{ buttonText }}
            </button>
        </div>
    </section>
</template>

<script>
export default {
    name: 'BannerWithButton',
    props: {
        image: {
            type: String,
            required: false
        },
        backgroundColor: {
            type: String,
            required: false
        },
        message: {
            type: String,
            required: true
        },
        messageColor: {
            type: String,
            required: false
        },
        buttonText: {
            type: String,
            required: false
        },
        buttonColor: {
            type: String,
            required: false
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.banner-with-button {
    @include display-flex();
    @include flex-direction(row);
    @include align-items(center);
    @include justify-content(space-between);
    position: relative;
    width: 100%;
    height: fit-content;
    margin: 0;
    padding: 0;

    .banner-content {
        @include display-flex();
        @include flex-direction(row);
        @include align-items(center);
        @include justify-content(space-between);
        width: 100%;
        padding: 12px 16px;
        border-radius: 8px;
        gap: 8px;

        .banner-content-inner {
            @include display-flex();
            @include flex-direction(row);
            @include align-items(center);
            flex: 1;
            gap: 12px;

            p {
                padding: 0 !important;
            }

            .banner-image-container {
                @include display-flex();
                @include align-items(center);
                @include justify-content(center);
                flex-shrink: 0;
                height: 24px;
                width: 24px;

                .banner-image {
                    height: 100%;
                    width: 100%;
                    object-fit: contain;
                    display: block;
                }
            }

            .banner-text {
                margin: 0;
                flex: 1;
                font-size: 14px;
                line-height: 1.4;
            }
        }

        .banner-button {
            font-size: 14px;
            cursor: pointer;
            border: none;
            background: transparent;
            padding: 0;
            font-family: $text-bold;
            text-decoration: underline;
        }
    }
}

// Banner background colors
.banner-background-color-blue {
    background-color: $color-info-100;
}

.banner-background-color-green {
    background-color: $color-success-100;
}

.banner-background-color-red {
    background-color: $color-error-100;
}

.banner-background-color-warning {
    background-color: $color-warning-100;
}

// Banner message colors
.banner-text.banner-message-color-blue {
    color: $color-info-500 !important;
}

.banner-text.banner-message-color-warning {
    color: $color-warning-800 !important;
}
</style>

<style lang="scss">
.banner-text.banner-message-color-blue b {
    color: $color-info-500 !important;
    font-family: $text-bold !important;
    font-weight: bold !important;
}

.banner-text.banner-message-color-warning b {
    color: $color-warning-800 !important;
    font-family: $text-bold !important;
    font-weight: bold !important;
}

.banner-button-color-blue {
    color: $color-info-500;
}

.banner-button-color-warning {
    color: $color-warning-800;
}
</style>
